module.exports = __webpack_public_path__ + "img/threeGreen.0846aa77.jpg";